module.exports = __webpack_public_path__ + "static/media/002.e9bd0e73.jpg";